"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function openModal(modal, src) {
    return {
        type: constants_1.ACTIONS.Landing.SHOW_MODAL,
        payload: {
            modal,
            src
        }
    };
}
exports.openModal = openModal;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/LandingActions.ts
// module id = 606
// module chunks = 0 1 2